import { ComponentType } from 'react';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import { store } from '../store';
import i18n from '../../../i18n';

import ErrorBoundary from './error-boundary';

export const withProviders = (WrappedComponent: ComponentType) => {
  const displayName = WrappedComponent.displayName ?? WrappedComponent.name;

  const ComponentWithProviders = (props: Record<string, unknown>) => (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <ErrorBoundary>
          <HashRouter>
            <WrappedComponent {...props} />
          </HashRouter>
        </ErrorBoundary>
      </Provider>
    </I18nextProvider>
  );

  ComponentWithProviders.displayName = `withProviders(${displayName})`;

  return ComponentWithProviders;
};
